/* eslint-disable camelcase */
export const GetCollectionAttributes = async (collection: string) =>
  fetch(`/api/public/collections/${collection}/attributes`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const GetCollectionAttributeValues = async (collection: string, attribute: string, other_attributes: string) =>
  fetch(`/api/public/collections/${collection}/attributes/${attribute}/values?${other_attributes}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());
